import { FC, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { IColumnProps } from "../../../../../interfaces/tables";
import { IResumeScanner } from "../../../../../interfaces/services";

import DataTable from "../../../tables/DataTable";
import Drawer from "../Drawer";
import Loader from "../../../../reusables/Loader";
import { PDFViewer } from "../../../../wrappers/PDFViewer";

import { useGetCareersMedia } from "../../../../../hooks/misc";
import { Icons } from "../../../../../data/Assets";

interface IScannerViewProps {
  goBackRoute: string | null;
  linked: boolean;
  resumeScans: IResumeScanner[];
  isLoading: boolean;
}

const ScannerView: FC<IScannerViewProps> = (props: IScannerViewProps) => {
  const { resumeScans, isLoading } = props;
  const navigate = useNavigate()
  const { studentId: studentIdParam } = useParams();
  const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedResumeScan, setSelectedResumeScan] = useState<IResumeScanner | null>(null);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const { data: media, isLoading: isMediaLoading } = useGetCareersMedia(studentId, selectedResumeScan?.media_id ?? 0)

  const handlePreviewClick = (id: number) => {
    const resumeScan = resumeScans.find(resume => resume.resume_scan.id === id);
    if (resumeScan) {
      setSelectedResumeScan(resumeScan);
      setPdfUrl(media?.url ?? null);
      setIsDrawerOpen(true);
    }
  };


  const columns: IColumnProps[] = [
    { name: "Resume Title", identifier: "resumeTitle" },
    { name: "Job Title", identifier: "jobTitle" },
    { name: "Date", identifier: "date" },
    { name: "Results", identifier: "results" },
    { name: "Reviewed by", identifier: "reviewedBy" },
  ];

  const resumeScanList = resumeScans.map((resumeScan, index) => ({
    id: resumeScan.resume_scan.id,
    studentId: studentId,
    resumeTitle: resumeScan.resume.title || `Resume ${index + 1}`,
    jobTitle: resumeScan.resume_scan.job_title,
    date: resumeScan.resume_scan.created_at,
    results: resumeScan.overall_score,
    reviewedBy: 'AI'
  }));

  return (
    <div className="immersion__student__resume__scanner__page_view">
      {/* <div className="immersion__student__resume__scanner_section">
        <div className="immersion__student__resume__scanner_section_left">
         Left section if needed
        </div>
        <div className="immersion__student__resume__scanner_section_right">
          <button className="immersion__btn immersion__btn_outline">
            <SVGIcon src={Icons.UploadOutline} color="primary" />
            <span>Upload</span>
          </button>
        </div>
      </div > */}
      <DataTable
        columns={columns}
        list={resumeScanList}
        isLoading={isLoading}
        titleIdentifier="resumeTitle"
        onCellClick={(id) => handlePreviewClick(id)}
        onTitleClick={(id) => navigate(`/students/${studentId}/scanner/${id}/details`)}
      />
      {selectedResumeScan && pdfUrl && (
        <Drawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          title={selectedResumeScan?.resume.title || "Resume Preview"}
          closeIcon={Icons.X}
        >
          {isMediaLoading ? (
            <Loader type="normal" text="Loading PDF..." />
          ) : (
            <PDFViewer signedUrl={pdfUrl ?? ""} scale={1} />
          )}
        </Drawer>
      )}
    </div >
  );
};
export default ScannerView;
